var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","max-width":_vm.maxWidth},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({style:({ cursor: 'help', marginLeft: _vm.marginLeft }),attrs:{"small":_vm.small,"color":_vm.color}},on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_c('span',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }